import { Modal } from "antd";
import React from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";

import { ContentLoader, FormField, FormFieldType } from "@components";
import { APP_STATES } from "@config/Applications";
import { ApplicationsActions, selectIsAddRiskModalLoading, selectCurrentApplication } from "@redux";
import {
  checkMax,
  checkMin,
  composeValidators,
  i18,
  numberFormat,
  required,
  trb
} from "@utilities";

import "./AddRiskModal.less";

const OVERIDE_RISK_OPTIONS = [
  {
    label: i18.ApplicationsLabels.LowRisk,
    value: "Low"
  },
  {
    label: i18.ApplicationsLabels.MediumRisk,
    value: "Medium"
  },
  {
    label: i18.ApplicationsLabels.HighRisk,
    value: "High"
  },
  {
    label: i18.ApplicationsLabels.UnacceptableRisk,
    value: "Unacceptable"
  }
];

export const AddRiskModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsAddRiskModalLoading);
  const application = useSelector(selectCurrentApplication);

  const overideRiskDefaultValue = application?.risks?.finalRisk || OVERIDE_RISK_OPTIONS[0].value;

  const handleSubmitAddRiskForm = async data => {
    if (!data.letChangeFinalRisk && data.overideRisk) {
      delete data.overideRisk;
    }

    try {
      await dispatch(
        ApplicationsActions.addRisk(application.id, data, i18.NotificationTitles.SuccessOperation)
      );
      await dispatch(ApplicationsActions.getApplication(application.id));
      onClose();
    } catch (e) {}
  };

  return (
    <Form
      onSubmit={handleSubmitAddRiskForm}
      render={({ handleSubmit, values }) => {
        return (
          <Modal
            visible
            onOk={handleSubmit}
            onCancel={onClose}
            okText={trb(i18.Buttons.Ok)}
            cancelText={trb(i18.Buttons.Cancel)}
          >
            <form id="addRisk" className="my-4" onSubmit={handleSubmit}>
              {isLoading && <ContentLoader />}
              {!isLoading && (
                <>
                  <FormField
                    name="comment"
                    component={FormFieldType.input}
                    title={trb(i18.ApplicationsLabels.Comment)}
                    validate={required}
                    size="large"
                    className="mb-3"
                  />
                  <FormField
                    name="description"
                    component={FormFieldType.input}
                    title={trb(i18.ApplicationsLabels.Description)}
                    validate={required}
                    size="large"
                    className="mb-3"
                  />
                  <FormField
                    name="score"
                    component={FormFieldType.number}
                    title={trb(i18.ApplicationsLabels.RiskScore)}
                    size="large"
                    className="mb-3"
                    validate={composeValidators(required, checkMax(100), checkMin(1))}
                    formatNumber={numberFormat().number}
                  />
                  {application?.state === APP_STATES.ONBOARDING_COMPLETE &&
                    values?.letChangeFinalRisk && (
                      <FormField
                        name="overideRisk"
                        component={FormFieldType.select}
                        options={OVERIDE_RISK_OPTIONS}
                        optionsLabel="label"
                        optionsValue="value"
                        className="mb-3"
                        validate={required}
                        initialValue={overideRiskDefaultValue}
                        size="large"
                      />
                    )}
                  {application?.state === APP_STATES.ONBOARDING_COMPLETE && (
                    <FormField
                      name="letChangeFinalRisk"
                      component={FormFieldType.checkbox}
                      size="large"
                      className="mt-4 add-risk-form-checkbox"
                      title={trb(i18.ApplicationsLabels.changeFinalRisk)}
                    />
                  )}
                </>
              )}
            </form>
          </Modal>
        );
      }}
    />
  );
};
